/**
=========================================================

* Tazi Rides Ltd has developed this dashboard based on a further configured version of the original template.
* Website: https://www.tazirides.co.uk
* All rights reserved.

=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React TS components
import { FormHelperText, OutlinedTextFieldProps, StandardTextFieldProps } from '@mui/material'

import MDInput from 'components/MDInput'

// Declaring props types for FormField
interface Props extends Omit<OutlinedTextFieldProps | StandardTextFieldProps, 'variant'> {
	label?: string
	required?: boolean
	[key: string]: any
}

function FormField({
	label,
	required,
	error,
	helperText,
	...rest
}: Props & { error?: boolean; helperText?: string }): JSX.Element {
	return (
		<div>
			<MDInput
				variant="standard"
				label={`${label}${required ? ' *' : ''}`}
				fullWidth
				InputLabelProps={{ shrink: true }}
				error={error}
				{...rest}
			/>
			{helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
		</div>
	)
}

// Declaring default props for FormField
FormField.defaultProps = {
	label: '',
}

export default FormField
